// extracted by mini-css-extract-plugin
export default {"accounts":"dbZo5","linked":"Bf2Dh","summary":"a6SGd"};